export const environment = {
  production: false,
  name: 'staging',

  apiUrl: '',
  socketUrl: '',

  features: {
    'module.admin': true,
    'module.admin.analytics': true,
    'module.admin.analytics_v2': true,
    'module.admin.datasets': true,
    'module.admin.learning': true,
    'module.admin.entity_types': true,
    'module.admin.protocols': true,
    'module.admin.sites': true,
    'module.admin.mes_files': true,
    'bot-response.avatar': 'yoshu_v2'
  }
}
